import {
  AppBar,
  Box,
  Container,
  Dialog,
  IconButton,
  Slide,
  Stack,
  Toolbar,
  Typography,
} from '@mui/material';
import { forwardRef, useEffect, useState } from 'react';
import { useValue } from '../../context/ContextProvider';
import { ArrowBackIos } from '@mui/icons-material';
// Import hooks for URL parameters and navigation
import { useParams, useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay, EffectCoverflow, Lazy, Zoom } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/effect-coverflow';
import 'swiper/css/lazy';
import 'swiper/css/zoom';
import './swiper.css';
import { createTheme } from '@mui/material/styles';
import '../addPoint/addDetails/quill.css'
import { Link } from 'react-router-dom';

  const theme = createTheme({
    palette: {
      ochre: {
        main: '#c8494d',  /*this changes the main navbar color '#1292c9'*/
        light: '#E9DB5D',
        dark: '#A29415',
        contrastText: '#f7f7f7',
      },
    },
  });

const Transition = forwardRef((props, ref) => {
  return <Slide direction="up" {...props} ref={ref} />;
});

const Point = () => {
  // 1. Get 'id' from URL (must match path="/point/:id" in App.js)
  const { id } = useParams(); 
  
  // 2. Extract the actual database ID from the slug
  const actualId = id?.includes('-') ? id.split('-')[0] : id;
  
  const navigate = useNavigate();
  const {
    state: { point, points },
    dispatch,
  } = useValue();

  const [place, setPlace] = useState(null);

  // 3. Fetch Data Logic
  useEffect(() => {
    const fetchPoint = async () => {
      try {
        // Use a relative path or your verified ENV variable
        const url = `${process.env.REACT_APP_SERVER_PROD_URL}/point/${actualId}`;
        console.log("Fetching from:", url); // Debugging link in console
        
        const response = await fetch(url);
        const data = await response.json();
        
        if (data.success) {
          dispatch({ type: 'UPDATE_POINT', payload: data.result });
        }
      } catch (error) {
        console.error("Fetch error:", error);
      }
    };

    if (actualId) {
      // Find in existing global list
      const selectedPoint = points.find((p) => p._id === actualId);
      
      if (selectedPoint) {
        dispatch({ type: 'UPDATE_POINT', payload: selectedPoint });
      } else if (!point || point._id !== actualId) {
        // If not in list, fetch it from backend
        fetchPoint();
      }
    }
  }, [actualId, points, dispatch, point]);

  // 4. Fetch Mapbox Geocoding data
  useEffect(() => {
    if (point && point.lng && point.lat) {
      const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${point.lng},${point.lat}.json?access_token=${process.env.REACT_APP_MAP_TOKEN}`;
      fetch(url)
        .then((response) => response.json())
        .then((data) => {
          if (data.features) setPlace(data.features[0]);
        });
    }
  }, [point]);

  const handleClose = () => {
    dispatch({ type: 'UPDATE_POINT', payload: null });
    navigate('/');
  };

  return (
    <Dialog
      fullScreen
      open={Boolean(actualId)}
      onClose={handleClose}
      TransitionComponent={Transition}
    >
      <AppBar theme={theme} color="ochre" position="relative">
        <Toolbar>
          <Typography variant="h6" component="h1" sx={{ ml: 2, flex: 1 }}>
            {point?.title || 'Loading...'}
          </Typography>
          <IconButton color="inherit" onClick={handleClose}>
            <ArrowBackIos />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Container sx={{ pt: 5 }}>
        <Swiper
          modules={[Navigation, Autoplay, EffectCoverflow, Lazy, Zoom]}
          centeredSlides
          slidesPerView={2}
          grabCursor
          navigation
          autoplay
          lazy
          zoom
          effect="coverflow"
          coverflowEffect={{
            rotate: 50,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: true,
          }}
        >
          {point?.images?.map((url, index) => (
            <SwiperSlide key={url}>
              <div className="swiper-zoom-container">
                <img src={url} alt={`${point?.title} - View ${index + 1}`}  />
              </div>
            </SwiperSlide>
          ))}
          
        </Swiper>
        
        <Stack sx={{ p: 3 }} spacing={2}>
          <Stack
            direction="row"
            sx={{
              justifyContent: 'space-between',
              flexWrap: 'wrap',
            }}
          >
            <Box>
              <Typography variant="h6" component="span">
                {'Place Name: '}
              </Typography>
              <Typography component="span">{place?.text}</Typography>
            </Box>
            <Box>
              <Typography variant="h6" component="span">
                {'Address: '}
              </Typography>
              <Typography component="span">{place?.place_name}</Typography>
            </Box>
          </Stack>
          <Stack>
            <Typography variant="h6" component="span">
              {'Details: '}
            </Typography>

          <div 
            style={{ 
              whiteSpace: "pre-line", // Preserves old \n breaks
              lineHeight: "1.6",
              color: "rgba(0, 0, 0, 0.87)" 
            }}
            dangerouslySetInnerHTML={{ __html: point?.description }} 
          />


          </Stack>
          <Stack>
            <Typography variant="h6" component="span">
              {'Tags: '}
            </Typography>
            <Typography component="span">
              {point?.pointTags ? point.pointTags.join(', ') : ''}
            </Typography>
          </Stack>

          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{ mt: 4, pt: 3, borderTop: '1px solid #eee' }}
          >
            {/* PREVIOUS BUTTON */}
            {point?.navigation?.prev?.url ? (
              <Button
                variant="outlined"
                component={Link} // Use the Link component from your router
                to={point.navigation.prev.url} // Standard 'to' or 'href' attribute
                startIcon={<ArrowBackIos />}
                onClick={() => navigate(point.navigation.prev.url)}
                sx={{ textTransform: 'none', borderRadius: '8px' }}
              >
                <Box sx={{ textAlign: 'left' }}>
                  <Typography variant="caption" sx={{ display: 'block', opacity: 0.7 }}>PREVIOUS</Typography>
                  <Typography variant="body2" sx={{ fontWeight: 600 }}>
                    {point.navigation.prev.title || 'Back'}
                  </Typography>
                </Box>
              </Button>
            ) : (
              <Box /> 
            )}

            {/* CENTER "HOME" BUTTON (Optional) */}
          <Button 
            variant="outlined"
            onClick={handleClose} 
            sx={{ 
              textTransform: 'none', 
              borderRadius: '8px',
              color: 'text.secondary',
              borderColor: '#ddd',
              px: 3,
              '&:hover': {
                borderColor: '#bbb',
                backgroundColor: 'rgba(0, 0, 0, 0.04)'
              }
            }}
          >
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="caption" sx={{ display: 'block', opacity: 0.7 }}>
                EXIT
              </Typography>
              <Typography variant="body2">
                View More Points
              </Typography>
            </Box>
          </Button>

            {/* NEXT BUTTON */}
            {point?.navigation?.next?.url ? (
              <Button
                variant="outlined"
                component={Link} // Use the Link component from your router
                to={point.navigation.next.url} // Standard 'to' or 'href' attribute
                endIcon={<ArrowBackIos sx={{ transform: 'rotate(180deg)' }} />}
                onClick={() => navigate(point.navigation.next.url)}
                sx={{ textTransform: 'none', borderRadius: '8px' }}
              >
                <Box sx={{ textAlign: 'right' }}>
                  <Typography variant="caption" sx={{ display: 'block', opacity: 0.7 }}>NEXT</Typography>
                  <Typography variant="body2" sx={{ fontWeight: 600 }}>
                    {point.navigation.next.title || 'Continue'}
                  </Typography>
                </Box>
              </Button>
            ) : (
              <Box />
            )}
          </Stack>


        </Stack>
      </Container>
    </Dialog>
  );
};

export default Point;



